/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AppConfig } from '../models/app-config';
import { getLogo } from '../fn/app-configs/get-logo';
import { GetLogo$Params } from '../fn/app-configs/get-logo';
import { listAppConfigs } from '../fn/app-configs/list-app-configs';
import { ListAppConfigs$Params } from '../fn/app-configs/list-app-configs';
import { LogoResponseDto } from '../models/logo-response-dto';

@Injectable({ providedIn: 'root' })
export class AppConfigsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appConfigControllerListAppConfigs()` */
  static readonly AppConfigControllerListAppConfigsPath = '/app-configs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAppConfigs()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAppConfigs$Response(
    params?: ListAppConfigs$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<AppConfig>>> {
    return listAppConfigs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAppConfigs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAppConfigs(params?: ListAppConfigs$Params, context?: HttpContext): Observable<Array<AppConfig>> {
    return this.listAppConfigs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AppConfig>>): Array<AppConfig> => r.body)
    );
  }

  /** Path part for operation `appConfigControllerGetLogo()` */
  static readonly AppConfigControllerGetLogoPath = '/app-configs/logo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLogo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLogo$Response(params?: GetLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<LogoResponseDto>> {
    return getLogo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLogo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLogo(params?: GetLogo$Params, context?: HttpContext): Observable<LogoResponseDto> {
    return this.getLogo$Response(params, context).pipe(
      map((r: StrictHttpResponse<LogoResponseDto>): LogoResponseDto => r.body)
    );
  }
}
